<template>
  <div >
    <div>
  <el-breadcrumb separator-class="el-icon-arrow-right">
  <!-- <el-breadcrumb-item :to="{ path: '/text' }">老师个人系统</el-breadcrumb-item> -->
  <el-breadcrumb-item>工作汇报</el-breadcrumb-item>
  <el-breadcrumb-item>工作汇报查看</el-breadcrumb-item>
</el-breadcrumb>
    </div>
 
<el-card>
 <el-row>
  <el-col :span="4"><div class="grid-content bg-purple-dark"><el-input v-model="searDate"  @keyup.enter.native="TitleList" placeholder="请输入标题"></el-input></div></el-col>
  <el-col :span="8">
          <div class="block">
    <el-date-picker
      v-model="value2"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      :picker-options="pickerOptionss">
    </el-date-picker>
  </div>
        </el-col>
    <el-col :span="2"><div class="grid-content bg-purple"> <el-button type="primary" @click="TitleList">查询</el-button></div></el-col>
  <el-col :span="2"><div class="grid-content bg-purple-light"> <el-button type="primary" @click="insertWork">添加</el-button></div></el-col>
   <el-col :span="3"> <p class="lableforSearch">查询到{{Worklist.length}}条数据</p></el-col>

</el-row>

 <el-table
    ref="multipleTable"
    :data="Worklist"
    border
    show-overflow-tooltip="true"
    tooltip-effect="dark"
    style="width: 100%"
    @selection-change="handleSelectionChange"
    >
    
    <!-- <el-table-column
      type="selection"
      width="55">
    </el-table-column> -->
    <el-table-column
      label="填写人"
      width="120"
      :show-overflow-tooltip="true"
      prop="name">
      
    </el-table-column>
    <el-table-column
      label="汇报标题"
      width="120"
      :show-overflow-tooltip="true"
      prop="work_TITLE">
      
    </el-table-column>
    
    <el-table-column
      prop="work_CONTENT"
      label="今日完成"
      :show-overflow-tooltip="true"
      width="150">
    </el-table-column>
     <el-table-column
      prop="problem"
      :show-overflow-tooltip="true"
      label="存在问题"
      width="150">
    </el-table-column>
     <el-table-column
      prop="proposal"
      :show-overflow-tooltip="true"
      label="其他建议"
      width="150">
    </el-table-column>
     <el-table-column
      prop="createDate"
      label="汇报时间"
      width="180">
    </el-table-column>
    <el-table-column
      prop="checkWork"
      label="是否查看"
      :formatter="stateFormat"
      width="140">
    </el-table-column>
    <el-table-column
      prop="username"
      label="审核账户"
      width="150">
    </el-table-column>
    <el-table-column
      prop="message"
      label="留言"
      width="150">
    </el-table-column>


 <el-table-column
      label="操作"
      width="240">

        <template slot-scope="scope" >
<el-button v-if="scope.row.checkWork!=1"  @click="updateNew(scope.row)"  ><svg class="icon" aria-hidden="true"><use xlink:href="#icon-xiugai"></use></svg></el-button>
<el-button  v-if="scope.row.checkWork!=1"   @click="deleteworks(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-shanchu"></use></svg></el-button>
<el-button   @click="showsWork(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-chakan2"></use></svg></el-button>
      </template>
    </el-table-column>

  </el-table>
  <!-- <div style="margin-top: 20px">
    <el-button @click="deleteSelection()">批量删除</el-button>
    <el-button @click="toggleSelection()">取消选择</el-button>
  </div> -->

</el-card>

<el-dialog
  title="工作汇报修改"
  :visible.sync="updataVisible"
  width="50%"
 >
  <el-form :model="updataForm" :rules="updateRules" ref="updateForms" label-width="100px" class="demo-ruleForm">
  <el-form-item label="汇报标题" prop="work_TITLE">
    <el-row>
    <el-col :span="12"><el-input v-model="updataForm.work_TITLE" readonly></el-input></el-col>
    <el-col :span="8"> 
      <el-date-picker
      @change="changeTime('update')"
      v-model="value1"
      type="week"
      format="yyyy 第 WW 周"
      placeholder="选择自然周">
    </el-date-picker>
  </el-col>
  <el-col :span="4"><el-input placeholder="课程周" type="number" @change="changeTime('update')" oninput="if(value.length>2)value=value.slice(0,2)"  v-model="studentWeek"></el-input></el-col>
   </el-row>
  </el-form-item>
  <el-form-item label="完成工作" prop="work_CONTENT">
    <el-input type="textarea" v-model="updataForm.work_CONTENT"></el-input>
  </el-form-item>
  <el-form-item label="存在问题" prop="problem">
    <el-input type="textarea" v-model="updataForm.problem"></el-input>
  </el-form-item><el-form-item label="其他建议" prop="proposal">
    <el-input type="textarea" v-model="updataForm.proposal"></el-input>
  </el-form-item>


  <el-form-item>
    <el-button type="primary" @click="updateForm">提交</el-button>
    <el-button type="primary" @click="update=true">预览</el-button>
  </el-form-item>
</el-form>
</el-dialog>


<el-dialog
  title="工作汇报"
  :visible.sync="dialogVisible"
  width="50%"
 >
  <!-- 添加工作 -->
  <el-form :model="ruleForm" :rules="rules" ref="ruleForms" label-width="100px" class="demo-ruleForm">
  <el-form-item label="汇报标题" prop="WORK_TITLE">
   <el-row>
    <el-col :span="12"><el-input v-model="ruleForm.WORK_TITLE" readonly></el-input></el-col>
    <el-col :span="8"> 
      <el-date-picker
      @change="changeTime('insert')"
      v-model="value1"
      type="week"
      format="yyyy 第 WW 周"
      placeholder="选择自然周">
    </el-date-picker>
  </el-col>
  <el-col :span="4"><el-input placeholder="课程周" type="number" @change="changeTime('insert')" oninput="if(value.length>2)value=value.slice(0,2)"  v-model="studentWeek"></el-input></el-col>
   </el-row>
    
  </el-form-item>
  <el-form-item label="完成工作" prop="WORK_CONTENT">
    <el-input type="textarea" v-model="ruleForm.WORK_CONTENT"></el-input>
  </el-form-item>
  <el-form-item label="存在问题" prop="problem">
    <el-input type="textarea" v-model="ruleForm.problem"></el-input>
  </el-form-item><el-form-item label="其他建议" prop="proposal">
    <el-input type="textarea" v-model="ruleForm.proposal"></el-input>
  </el-form-item>
  <el-form-item label="是否已完成" prop="WORK_COMPLETE" v-show="false" >
   <el-radio-group v-model="ruleForm.WORK_COMPLETE" size="medium">
      <el-radio border label="0">进行中</el-radio>
      <el-radio border label="1">已完成</el-radio>
    </el-radio-group>
    </el-form-item>
    <el-form-item label="时间" prop="value1" v-show="false">
    <el-date-picker
      v-model="ruleForm.value1"
      type="datetimerange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
  </el-form-item>

  <el-form-item label="汇报时间">
    <el-date-picker
      v-model="ruleForm.createDate"
      type="datetime"
      placeholder="选择日期时间"
      align="right"
       :picker-options="pickerOptions"
      value-format="yyyy-MM-dd HH:mm:ss"
      default-time	
      >
    </el-date-picker>
  </el-form-item>

  <el-form-item>
    <el-button type="primary" @click="submitForm('ruleForms')">提交</el-button>
    <el-button type="primary" @click="catInsert=true">预览</el-button>
    <el-button @click="resetForm('ruleForms')">重置</el-button>
  </el-form-item>
</el-form>
</el-dialog>
     <el-dialog
      width="80%"
     
      :visible.sync="catInsert"
      append-to-body>
      <InsertWorkModel  :WORK_CONTENT="ruleForm.WORK_CONTENT"  :title="ruleForm.WORK_TITLE" :problem="ruleForm.problem" :createDate="ruleForm.createDate" :proposal="ruleForm.proposal"></InsertWorkModel>
    </el-dialog>

      <el-dialog
      width="80%"
      
      :visible.sync="catwork"
      append-to-body>
      <InsertWorkModel  :WORK_CONTENT="workshowlist.work_CONTENT"  :name="name" :title="workshowlist.work_TITLE" :problem="workshowlist.problem" :proposal="workshowlist.proposal" :createDate="workshowlist.createDate" ></InsertWorkModel>
    </el-dialog>

    <el-dialog
      width="80%"
      :visible.sync="update"
      append-to-body>
      <InsertWorkModel  :WORK_CONTENT="updataForm.work_CONTENT"  :title="updataForm.work_TITLE" :problem="updataForm.problem" :createDate="updataForm.createDate" :proposal="updataForm.proposal"></InsertWorkModel>
    </el-dialog>

<el-dialog
  title="选择导师"
  :visible.sync="showVisible"
  width="50%"
 >
   <el-select v-model="teacher" placeholder="请选择">
    <el-option
      v-for="item in teacherList"
      :key="item.userid"
      :label=item.name
      :value="item.userid"
      >
    </el-option>
  </el-select>
  <span slot="footer" class="dialog-footer">
     
    <el-button @click="showVisible = false">取 消</el-button>
    <el-button type="primary" @click="onSubselectTer">提交</el-button>
  </span>
</el-dialog>
  </div>
</template>

<script>
import InsertWorkModel from '@/components/work/student/InsertWorkModel.vue'
export default {
  components:{  
    InsertWorkModel,
},
  created(){
    this.getwork()
    

  },
data(){
    return{
      pickerOptionss: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
        },
        value1:'',
        studentWeek:'',
        name:'',
        value2:'',
        multipleSelection: [],
        searDate:'',
        update:false,
        tableData:[],
        Worklist:[],
        workshowlist:{},
        searTitleList:[],
        catwork:false,
        catInsert:false,
        teacherList:[],
        teacher:'',
        showVisible:false,
        dialogVisible: false,
        ruleForm:{
        WORK_TITLE:'',
        WORK_CONTENT:'',
        WORK_COMPLETE:'1',
        proposal:'',
        problem:'',
        userid:'',
        createDate:'',
         value1: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)],
        work_BEGIN_TIME:'',
        work_END_TIME:'',        },
        updataVisible:false,
        updataForm:{
        work_TITLE:'',
        work_CONTENT:'',
        problem:'',
        proposal:'',
        work_ID:'',
        },
        rules:{
             WORK_TITLE: [
            { required: true, message: '汇报标题', trigger: 'blur' },
            { min: 3, max: 50, message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ],
            WORK_CONTENT: [
            { required: true, message: '汇报内容', trigger: 'blur' },
            { min: 3, max: 200, message: '长度在 3 到 200 个字符', trigger: 'blur' }
          ],        

              WORK_COMPLETE: [
            { required: true, message: '请选择汇报进度', trigger: 'blur' },
    
          ],
          value1:[
              { required: true, message: '汇报内容', trigger: 'blur' }
          ]
    
        },
        updateRules:{
          work_TITLE: [
            { required: true, message: '汇报标题', trigger: 'blur' },
            { min: 3, max: 50, message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ],
          work_CONTENT: [
            { required: true, message: '汇报内容', trigger: 'blur' },
            { min: 3, max: 200, message: '长度在 3 到 200 个字符', trigger: 'blur' }
          ],
        }
           
        
    }
},
 props:['user'],
methods:{
   getwork(){ 
    this.ruleForm.createDate =this.format(new Date(),'yyyy-MM-dd HH:mm:ss')
    this.ruleForm.userid=JSON.parse(localStorage.getItem('user')).userid
    console.log(this)
    
             this.axios.post("/work/getWork",'userid='+this.ruleForm.userid)
             .then(resp=>{
              if(resp.data.status==1){
                console.log(resp.data.result)
               resp.data.result.work_END_TIME= this.format( resp.data.result.work_END_TIME,'yyyy-MM-dd HH:mm:ss')
              this.Worklist=resp.data.result
              }
             })

      this.axios.post("/user/getUser",'type=0')
             .then(res=>{
              if(res.data.status==1){
                console.log(res.data.result)
               this.teacherList=res.data.result
              
              }
             })


  },      
   changeTime(data){
    let val=this.value1
    if(data=='insert'){
      if(!(val==null||val==''||this.studentWeek=='')){
        let weekDate=  this.$formateDate.getWeek(val)
        this.ruleForm.WORK_TITLE='第'+this.studentWeek+'教学周'+weekDate
      }else{
        this.ruleForm.WORK_TITLE=''
      }
    }else{console.log('修改')
      if(!(val==null||val==''||this.studentWeek=='')){
        let weekDate=  this.$formateDate.getWeek(val)
         this.updataForm.work_TITLE=weekDate+'日 第'+this.studentWeek+'课程周'
          console.log('修改'+this.updateForm.WORK_TITLE)
      }else{
        this.updataForm.work_TITLE=null
      }
    }

     
        
      },
      reset(){
        console.log('重置')
        this.ruleForm.WORK_TITLE=''
        this.updateForm.WORK_TITLE=''
        this.value1=''
        this.studentWeek=''
      },
      stateFormat(row, column) {
    if (row.checkWork === null) {
      return '未查看'
    } else if(row.checkWork==0){
      return '未通过'
    }else  {
      return '已查看'
    } 
  },TitleList(){
    const starDate=this.format(this.value2[0], 'yyyy-MM-dd HH:mm:ss')
      const endDate=this.format(this.value2[1], 'yyyy-MM-dd HH:mm:ss')
    if(this.searTitleList.length<=0){
          this.searTitleList=this.Worklist
        }
        this.Worklist=this.searTitleList
        // .includes
        this.Worklist=this.Worklist.filter((item)=>{
         if(this.searDate!=''){
          return item.work_TITLE.includes(this.searDate)
         }else{
          return true
         }     
        })

        
        this.Worklist=this.Worklist.filter((item)=>{
         if(this.value2.length>0){
          return starDate<item.createDate&&item.createDate<endDate
         }else{
          return true
         }     
        })

       
  },
    showsWork(date){
      this.catwork=true
      this.name=date.name
      this.axios.post("/work/getWorkByWorkid","wordid="+date.work_ID)
     .then(resp=>{
      if(resp.data.status===1){
        this.workshowlist=resp.data.result[0]
        console.log(resp.data.result)
      }
     })
    },  updateNew(data){
      this.reset()
      console.log(data)
       this.updataVisible=true
       this.updataForm.work_TITLE=data.work_TITLE
       this.updataForm.work_CONTENT=data.work_CONTENT
       this.updataForm.problem=data.problem
       this.updataForm.proposal=data.proposal
       this.updataForm.work_ID=data.work_ID
      },updateForm(){
        this.$refs.updateForms.validate((valid) => {
          if (valid) {
             let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };    
             this.axios.post("/work/updateWork",this.updataForm,config)
             .then(resp=>{
              if( resp.data.status==1){
                this.$message(
                  {message:'修改成功',
                  type:'success'}
                )
               
                this.getwork()
                this.updataVisible=false
              }
             
             })
          } else {
            console.log('error submit!!');
            return false;
          }

          
        });
      },

      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
        insertWork(){
          this.reset()
            this.dialogVisible = true
        
    },deleteworks(date){
      const that=this
        this.$confirm("确定删除？","提示",{
          confirmButtonText: "确认",//确认按钮文字更换
          cancelButtonText: "取消",//取消按钮文字更换
          showClose: true,//是否显示右上角关闭按钮
          type: "warning",//提示类型  success/info/warning/error
      }).then(function(){  
        console.log(date)
        that.axios.post("/work/deleteworks","userid="+date.userid+"&work_ID="+date.work_ID)
      .then(resp=>{
        if(resp.data.status==1){
          that.$message.success("删除成功")
          that.getwork()
        }
        
      }) .catch((err) => {
                                alert("出错了")
                                console.log(err)
                            })  
      }).catch(()=>{});
     
    },
    toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      deleteSelection(){
          let config = {
        headers: { "Content-Type": "application/json" }
      };    
        console.log(this.multipleSelection)
        if(this.multipleSelection.length===0)
        retun 
       this.axios.post("/work/deleteMoreWorks",this.multipleSelection,config)
       .then(resp=>{
        console.log(resp.data)
        if(resp.data.status==1){
        this.$message.success("删除成功")
        this.getwork()
        }else{
          this.$message.error(resp.data.message)
        }
       })
      },selectTeacher(){
       this.showVisible=true;
      },
      onSubselectTer(){
         this.axios.post("/user/updateUserTeacherID",'userid='+this.ruleForm.userid+"&teacherid="+this.teacher)
         .then(resp=>{
          if(resp.data.status==1){
            this.$message.success("选择成功")
            this.showVisible=false
          }else{
             this.$message.error("失败")
          }
         })
      //this.showVisible=false
      },
    submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
             let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };    
        
        this.ruleForm.work_BEGIN_TIME=this.format(this.ruleForm.value1[0],'yyyy-MM-dd HH:mm:ss')
        
       
        this.ruleForm.work_END_TIME=this.format(this.ruleForm.value1[1],'yyyy-MM-dd HH:mm:ss')
        this.ruleForm.userid=JSON.parse(localStorage.getItem('user')).userid
             this.axios.post("/work/insertWork",this.ruleForm,config)
             .then(resp=>{
              if( resp.data.status==1){
                this.$message(
                  {message:'添加成功',
                  type:'success'}
                )
                 this.$refs[formName].resetFields();
                this.getwork()
                this.dialogVisible=false
              }
             
             })
          } else {
            console.log('error submit!!');
            return false;
          }

          
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
       format(time, format) {
                var t = new Date(time);
                var tf = function (i) { return (i < 10 ? '0' : '') + i };
                return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
                    switch (a) {
                        case 'yyyy':
                            return tf(t.getFullYear());
                            break;
                        case 'MM':
                            return tf(t.getMonth() + 1);
                            break;
                        case 'mm':
                            return tf(t.getMinutes());
                            break;
                        case 'dd':
                            return tf(t.getDate());
                            break;
                        case 'HH':
                            return tf(t.getHours());
                            break;
                        case 'ss':
                            return tf(t.getSeconds());
                            break;
                    }
                })
            }

    },

}

</script>

<style>
.report_content{
    width: 100%;
    height: 100%;
    background-color: red;
}
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
 .lableforSearch{
      margin-top:8px;
      color:grey
}
</style>


// WEBPACK FOOTER //
// src/components/work/instructor/InstructorPeport.vue